import api from '../../plugins/api';

// Подтверждает SMS-код и запрашивает у backend Doscar данные цифрового
// удостоверения личности (ПКБ FCB ID OTP). requestId должен быть тем же,
// что вернул pkbFcbSendCode.
const pkbFcbGetDocument = (id, { requestId, code }) => {
  return api.post(`/api/crm/clients/${id}/fcbid/document`, { requestId, code });
};

export default pkbFcbGetDocument;